import { initializeApp, getApps, getApp } from 'firebase/app';

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
};

/** Returns the Firebase app instance, or null if Firebase is not configured. */
export function getFirebaseApp() {
  const projectId = firebaseConfig.projectId;
  const apiKey = firebaseConfig.apiKey;
  if (!projectId || projectId.startsWith('your_')) return null;
  if (!apiKey || apiKey.startsWith('your_')) return null;
  return getApps().length ? getApp() : initializeApp(firebaseConfig);
}
